import React from 'react';
import { useIntl } from 'react-intl';
import { Timezone } from 'Components/uiControls';
import { Grid } from '@mui/material';
import './index.scss';

const DateRangeInfo = ({ dateRange, dateformat, timeZone }) => {
    const { messages } = useIntl();

    return (
        <div className="date-range-tooltip-content">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div className="date-range-item">
                        <span className="date-range-label">
                            {messages['driver_performance_dateRange_startDate'] || 'Start Date'}:
                        </span>
                        <span className="date-range-value">
                            <Timezone
                                date={dateRange?.startDate}
                                dateFormat={dateformat}
                                timeFormat="hh:mm a"
                                timezone={timeZone}
                            />
                        </span>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="date-range-item">
                        <span className="date-range-label">
                            {messages['driver_performance_dateRange_endDate'] || 'End Date'}:
                        </span>
                        <span className="date-range-value">
                            <Timezone
                                date={dateRange?.endDate}
                                dateFormat={dateformat}
                                timeFormat="hh:mm a"
                                timezone={timeZone}
                            />
                        </span>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default DateRangeInfo;
